import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import { theme } from "Theme"
import Config from "Data"

import {
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share"

// slug.defaults.modes["pretty"] = {
//   replacement: "",
//   symbols: true,
//   remove: /[.]/g,
//   lower: false,
//   charmap: slug.charmap,
//   multicharmap: slug.multicharmap,
// }

const SocialShare = ({ title, description, banner, pathname, event, hashtags }) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: {
          defaultTitle,

          url,

          defaultDescription,
          defaultBanner,
        },
      },
    }) => {
      const seo = {
        title: title || defaultTitle,
        description: description.toString().replace("our", "CXOsync's") || defaultDescription,
        image: `${url}${banner || defaultBanner}`,
        url: `${url}${pathname.toString().replace(/\s+/g, "-").toLowerCase() || "/"}`,
      }
      let eventhashtags = event ? hashtags.join(",").replace(/\s+/g, "") : ""
      return (
        <div className="social-network-share-container">
          {/* <FacebookShareButton
            url={seo.url}
            quote={seo.description}
            className="social-network-share-button"
          >
            <FacebookIcon size={32} borderRadius={Number(`${theme.elementRadius}`)} />
          </FacebookShareButton> */}

          <TwitterShareButton
            url={seo.url}
            title={seo.title}
            via={`${Config.social.twitter}`}
            hashtags={Config.hashtags.concat(eventhashtags)}
            data-gtm={"Twitter share button"}
            className="social-network-share-button">
            <TwitterIcon size={32} borderRadius={Number(`${theme.elementRadius}`)} />
          </TwitterShareButton>

          <LinkedinShareButton
            url={seo.url}
            title={seo.title}
            description={seo.description}
            data-gtm={"LinkedIn share button"}
            windowWidth={800}
            windowHeight={600}
            className="social-network-share-button">
            <LinkedinIcon size={32} borderRadius={Number(`${theme.elementRadius}`)} />
          </LinkedinShareButton>

          {/* <WhatsappShareButton
            url={seo.url}
            title={seo.title}
            separator=":: "
            className="social-network-share-button"
          >
            <WhatsappIcon size={32} borderRadius={Number(`${theme.elementRadius}`)} />
          </WhatsappShareButton> */}

          <EmailShareButton
            url={seo.url}
            subject={seo.title}
            // body={seo.description}
            separator={"- "}
            className="social-network-share-button"
            data-gtm={"Email share button"}>
            <EmailIcon size={32} borderRadius={Number(`${theme.elementRadius}`)} />
          </EmailShareButton>

          {/* <span className="social-network-share-button">
            <p
              className=""
              style={{
                lineHeight: '1rem',
                margin: '22px 0',
                transform: 'rotate(-90deg)',
              }}
            >
              <b>Share:</b>
            </p>
          </span> */}
        </div>
      )
    }}
  />
)

export default SocialShare

SocialShare.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  banner: PropTypes.string,
  pathname: PropTypes.string,
  event: PropTypes.bool,
}

SocialShare.defaultProps = {
  title: null,
  desc: null,
  banner: null,
  pathname: null,
  event: false,
}

const query = graphql`
  query SocialShare {
    site {
      buildTime(formatString: "YYYY-MM-DD")
      siteMetadata {
        defaultTitle: title
        titleAlt
        brand
        author
        siteLanguage
        logo
        url
        pathPrefix
        defaultDescription: description
        defaultBanner: banner
        twitter
      }
    }
  }
`
